export const riviera = {
	"title": "Riviera Beachwear",
	"subtitle": "COLLECTION",
	"descriptionITA": "La nostra collezione di costumi da bagno è stata ispirata " +
        "per creare una collezione di costumi da bagno e copricostume che " +
        "riflettessero i colori caldi e le trame della \"Dolce Vita italiana\". " +
        "I nostri bikini e caftani sono tagliati con tessuti naturali come il " +
        "voile di cotone che danno una sensazione disinvolta e senza sforzo.",
    "descriptionENG": "Our beachwear collection was inspired to create a " +
        "collection of swimsuit and coverups that reflected the " +
        "warmth colors and textures of the “Italian Dolce Vita”. " +
        "Our bikini and Kaftans are cut from natural fabrics like " +
        "cotton voile that feel breezy and effortless."
};
export const rivieraProducts = [
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9705.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9705.jpg",
        "retromin": "",

        "prod1": "CAMICIA AURORA",
        "stile1": "Tigre Mare | Color Prints",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9711.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9711.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO GIORGIA",
        "stile1": "Tigre Mare | Color Prints",
        "taglia1": "TAGLIA U",

        "prod2": "COSTUME OLIMPIONICO",
        "stile2": "Tigre Mare | Color Prints",
        "taglia2": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9771.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9771.jpg",
        "retromin": "",

        "prod1": "COSTUME INTERO VOLANO",
        "stile1": "Tigre Mare | Color Prints",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "SPOLVERINO BELEN",
        "stile2": "Tigre Mare | Color Prints",
        "taglia2": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9780.jpg",
        "retro": "lookbook5/1_riviera/raw/0S6A9774.jpg",
        "photomin": "lookbook5/1_riviera/min/0S6A9780.jpg",
        "retromin": "lookbook5/1_riviera/min/0S6A9774.jpg",

        "prod1": "COSTUME INTERO VOLANO",
        "stile1": "Tigre Mare | Color Prints",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9736.jpg",
        "retro": "lookbook5/1_riviera/raw/0S6A9790.jpg",
        "photomin": "lookbook5/1_riviera/min/0S6A9736.jpg",
        "retromin": "lookbook5/1_riviera/min/0S6A9790.jpg",

        "prod1": "COSTUME OLIMPIONICO",
        "stile1": "Tigre Arancia | Color Prints",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9786.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9786.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO BELEN",
        "stile1": "Tigre Arancia | Color Prints",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "COSTUME OLIMPIONICO",
        "stile2": "Tigre Arancia | Color Prints",
        "taglia2": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9728.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9728.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO DIVA",
        "stile1": "Tigre Arancia | Color Prints",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9751.jpg",
        "retro": "lookbook5/1_riviera/raw/0S6A9746.jpg",
        "photomin": "lookbook5/1_riviera/min/0S6A9751.jpg",
        "retromin": "lookbook5/1_riviera/min/0S6A9746.jpg",

        "prod1": "SPOLVERINO DIVA",
        "stile1": "Tigre Peonia | Color Prints",
        "taglia1": "TAGLIA U",

        "prod2": "COSTUME FASCIA",
        "stile2": "Tigre Peonia | Color Prints",
        "taglia2": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9726.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9726.jpg",
        "retromin": "",

        "prod1": "COSTUME TRIANGOLO",
        "stile1": "Maiolica | Color Prints",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9717.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9717.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO DIVA",
        "stile1": "Maiolica | Color Prints",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9762.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9762.jpg",
        "retromin": "",

        "prod1": "COSTUME BALCONCINO",
        "stile1": "Cashmere Menta | Color Prints",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9757.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9757.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO POSITANO",
        "stile1": "Cashmere Menta | Color Prints",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9791.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9791.jpg",
        "retromin": "",

        "prod1": "PAREO",
        "stile1": "Cashmere Mare | Color Prints",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/1_riviera/raw/0S6A9798.jpg",
        "retro": "",
        "photomin": "lookbook5/1_riviera/min/0S6A9798.jpg",
        "retromin": "",

        "prod1": "COSTUME BALCONCINO",
        "stile1": "Cashmere Mare | Color Prints",
        "taglia1": "TAGLIA S.M.L"
    }
];


export const jungle = {
    "title": "Jungle",
    "subtitle": "COLLECTION",
    "descriptionITA": "Jungle è una collezione ispirata alle arti decorative e ai motivi naturali. I lini e i cotoni organici richiamano gli ornamenti e le decorazioni della giungla influenzati dal 18° secolo con maniche leggere e gonfie, vita molto stretta e gonne ariose. La nuova stagione è all'insegna delle stampe dai colori pop e soprattutto delle sfumature rosa-arancio.",
    "descriptionENG": "Jungle is a collection inspired by decorative arts and natural patterns. The organic linens and cottons recall jungle ornaments and decorations influenced by the 18th century with light and puffy sleeves, very tight waists and airy skirts. The new season is all about the pop colored prints and especially orange-pink nuances."
};
export const jungleProducts = [
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9578.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9578.jpg",
        "retromin": "",

        "prod1": "ABITO ELECTRA",
        "stile1": "Tigre Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9554.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9554.jpg",
        "retromin": "",

        "prod1": "PANTALONE SISMA",
        "stile1": "Tigre Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CAMICIA CERVARO",
        "stile2": "Arancia | Prints . Solid Colors",
        "taglia2": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9599.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9599.jpg",
        "retromin": "",

        "prod1": "ABITO ALIMINI",
        "stile1": "Tigre Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9599e.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9599e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0024",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9570.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9570.jpg",
        "retromin": "",

        "prod1": "TOP SALVA",
        "stile1": "Arancio | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "SHORT SISMA",
        "stile2": "Arancio | Prints . Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9575.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9575.jpg",
        "retromin": "",

        "prod1": "GIACCA CODRA",
        "stile1": "Tigre Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL"
    },
    {
        //todo: non ho inserito foto abbassata
        "photo": "lookbook5/2_jungle/raw/0S6A9666.jpg",
        "retro": "lookbook5/2_jungle/raw/0S6A9674.jpg",
        "photomin": "lookbook5/2_jungle/min/0S6A9666.jpg",
        "retromin": "lookbook5/2_jungle/min/0S6A9674.jpg",

        "prod1": "ABITO COSTARICA",
        "stile1": "Tigre Arancia | Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9689.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9689.jpg",
        "retromin": "",

        "prod1": "TOP CALA",
        "stile1": "Tigre Arancia | Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9691.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9691.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0023",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9622.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9622.jpg",
        "retromin": "",

        "prod1": "ABITO COPACABANA",
        "stile1": "Bianco | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9619.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9619.jpg",
        "retromin": "",

        "prod1": "ABITO AMBRA",
        "stile1": "Tigre Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9612.jpg",
        "retro": "lookbook5/2_jungle/raw/0S6A9609.jpg",
        "photomin": "lookbook5/2_jungle/min/0S6A9612.jpg",
        "retromin": "lookbook5/2_jungle/min/0S6A9609.jpg",

        "prod1": "ABITO PURE",
        "stile1": "Tigre Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9628.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9628.jpg",
        "retromin": "",

        "prod1": "ABITO SOLE",
        "stile1": "Arancia | Prints . Solid Colors",
        "taglia1": "TAGLIA U",

        "prod2": "CINTURA BZ0019",
        "stile2": "Prints . Solid Colors",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9560.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9560.jpg",
        "retromin": "",

        "prod1": "PANTALONE CAPRI",
        "stile1": "Bianco | Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "TOP SOGNO",
        "stile2": "Arancia | Solid Colors",
        "taglia2": "TAGLIA S.M.L.XL",

        "prod3": "ACCESSORIO TWILLY",
        "stile3": "Prints Color",
        "taglia3": "TAGLIA U",
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9633.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9633.jpg",
        "retromin": "",

        "prod1": "ABITO ORIANA",
        "stile1": "Tigre Arancia | Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A96344.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A96344.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0022",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/TOP BIANCA GONNA NEVE.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/TOP BIANCA GONNA NEVE.jpg",
        "retromin": "",

        "prod1": "TOP BIANCA",
        "stile1": "Tigre Arancia | Prints Color",
        "taglia1": "TAGLIA XS.S.L",

        "prod2": "GONNA NEVE",
        "stile2": "Tigre Arancia | Prints Color",
        "taglia2": "TAGLIA u"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9682e.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9682e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0029",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0122.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0122.jpg",
        "retromin": "",

        "prod1": "ABITO ANTIBE",
        "stile1": "Tigre Peonia | Prints Color",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/2_jungle/raw/CASACCA FIOCCO PANTALONE MUSA.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/CASACCA FIOCCO PANTALONE MUSA.jpg",
        "retromin": "",

        "prod1": "PANTALONE MUSA",
        "stile1": "Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "CASACCA FIOCCO",
        "stile2": "Tigre Peonia | Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0081.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0081.jpg",
        "retromin": "",

        "prod1": "ABITO GARDENIA",
        "stile1": "Tigre Peonia | Prints Color",
        "taglia1": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0081e.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0081e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0029",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0047.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0047.jpg",
        "retromin": "",

        "prod1": "ABITO ANNA",
        "stile1": "Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0045.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0045.jpg",
        "retromin": "",

        "prod1": "CAMICIA NODO",
        "stile1": "Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "SHORT SISMA",
        "stile2": "Peonia | Prints . Solid Colors",
        "taglia2": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0034.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0034.jpg",
        "retromin": "",

        "prod1": "TOP SALVA",
        "stile1": "Tigre Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "PANTALONE MUSA",
        "stile2": "Tigre Peonia | Prints . Solid Colors",
        "taglia2": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0022.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0022.jpg",
        "retromin": "",

        "prod1": "CAMICIA PANAMA",
        "stile1": "Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/BZ0030.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/BZ0030.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0030",
        "stile1": "Peonia | Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0063.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0063.jpg",
        "retromin": "",

        "prod1": "ABITO AMBRA",
        "stile1": "Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0040.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0040.jpg",
        "retromin": "",

        "prod1": "PANTALONE CAPRI",
        "stile1": "Peonia | Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CAMICIA MAKI",
        "stile2": "Peonia | Solid Colors",
        "taglia2": "TAGLIA S.M.L.XL",

        "prod3": "ACCESSORIO TWILLY",
        "stile3": "Prints Color",
        "taglia3": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0110.jpg",
        "retro": "lookbook5/2_jungle/raw/0S6A0114.jpg",
        "photomin": "lookbook5/2_jungle/min/0S6A0110.jpg",
        "retromin": "lookbook5/2_jungle/min/0S6A0114.jpg",

        "prod1": "ABITO LULU'",
        "stile1": "Ricamo Stampa Peonia",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/TOP EMILY GONNA CUBA.jpg",
        "retro": "lookbook5/2_jungle/raw/0S6A0179.jpg",
        "photomin": "lookbook5/2_jungle/min/TOP EMILY GONNA CUBA.jpg",
        "retromin": "lookbook5/2_jungle/raw/0S6A0179.jpg",

        "prod1": "TOP EMILY",
        "stile1": "Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA U",

        "prod2": "GONNA CUBA",
        "stile2": "Tigre Peonia | Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0103.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0103.jpg",
        "retromin": "",

        "prod1": "TOP CALA",
        "stile1": "Ricamo Tigre Peonia | Prints Color",
        "taglia1": "TAGLIA U",

        "prod2": "GONNA VODKA",
        "stile2": "Ricamo Tigre Peonia | Embroidery Sangallo & Ricamo Stampa Peonia",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0073.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0073.jpg",
        "retromin": "",

        "prod1": "ABITO ALENA",
        "stile1": "Ricamo Stampa Peonia | Embroidery Sangallo & Ricamo Stampa Peonia",
        "taglia1": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A0136.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A0136.jpg",
        "retromin": "",

        "prod1": "SHORT SAINT BARTH",
        "stile1": "Tigre Peonia | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "TOP SHOW",
        "stile2": "Peonia | Prints . Solid Colors",
        "taglia2": "TAGLIA S.M.L.XL",

        "prod3": "CINTURA BZ0019",
        "stile3": "Prints Color",
        "taglia3": "TAGLIA U",
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9488.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9488.jpg",
        "retromin": "",

        "prod1": "ABITO MOHITO",
        "stile1": "Tigre Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9536.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9536.jpg",
        "retromin": "",

        "prod1": "PANTALONE MARTE",
        "stile1": "Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CAMICIA NODO",
        "stile2": "Tigre Mare | Prints . Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9514.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9514.jpg",
        "retromin": "",

        "prod1": "TOP POLO",
        "stile1": "Tigre Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA U",

        "prod2": "PANTALONE MUSA",
        "stile2": "Tigre Mare | Prints . Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9514 copia.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9514 copia.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0028",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9549.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9549.jpg",
        "retromin": "",

        "prod1": "CAMICIA PINOT",
        "stile1": "Tigre Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "SHORT SISMA",
        "stile2": "Tigre Mare | Prints . Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL",

        "prod3": "CAPPELLO PESCATORE",
        "stile3": "Tigre Mare | Prints Color",
        "taglia3": "TAGLIA U",
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9485.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9485.jpg",
        "retromin": "",

        "prod1": "ABITO PUPA",
        "stile1": "Tigre Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9419.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9419.jpg",
        "retromin": "",

        "prod1": "ABITO MARTINA",
        "stile1": "Tigre Mare | Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9515.jpg",
        "retro": "lookbook5/2_jungle/raw/0S6A9521.jpg",
        "photomin": "lookbook5/2_jungle/min/0S6A9515.jpg",
        "retromin": "lookbook5/2_jungle/min/0S6A9521.jpg",

        "prod1": "TOP SALVA",
        "stile1": "Bianco | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "PANTALONE MARTE",
        "stile2": "Tigre Mare | Prints . Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL",

        "prod3": "GIACCA CODRA",
        "stile3": "Tigre Mare | Prints . Solid Colors",
        "taglia3": "TAGLIA XS.S.M.L.XL",
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9465.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9465.jpg",
        "retromin": "",

        "prod1": "ABITO DAFNE",
        "stile1": "Tigre Mare | Prints Color",
        "taglia1": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9385.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9385.jpg",
        "retromin": "",

        "prod1": "ABITO CONCHIGLIA",
        "stile1": "Tigre Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/SET MORENA ISLA.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/SET MORENA ISLA.jpg",
        "retromin": "",

        "prod1": "GONNA ISLA",
        "stile1": "Tigre Mare | Prints Color",
        "taglia1": "TAGLIA U",

        "prod2": "TOP MORENO",
        "stile2": "Tigre Mare | Prints Color",
        "taglia2": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9361.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9361.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ008",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9364.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9364.jpg",
        "retromin": "",

        "prod1": "SHORT SAINT BARTH",
        "stile1": "Tigre Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L.XL",

        "prod2": "TOP PALOMA",
        "stile2": "Tigre Mare | Prints Color",
        "taglia2": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9366.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9366.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0019",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/PANAREA.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/PANAREA.jpg",
        "retromin": "",

        "prod1": "ABITO PANAREA",
        "stile1": "Tigre Mare | Prints Color",
        "taglia1": "TAGLIA S.M.L.XL"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9456.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9456.jpg",
        "retromin": "",

        "prod1": "ABITO MAGNIFICO",
        "stile1": "Tigre Mare | Prints Color",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "FOULARD",
        "stile2": "Tigre Mare | Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9329.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9329.jpg",
        "retromin": "",

        "prod1": "GONNA VERMENTINO",
        "stile1": "Tigre Mare | Prints Color",
        "taglia1": "TAGLIA U",

        "prod2": "TOP BIANCA",
        "stile2": "Tigre Mare | Prints Color",
        "taglia2": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/2_jungle/raw/0S6A9336.jpg",
        "retro": "",
        "photomin": "lookbook5/2_jungle/min/0S6A9336.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0029",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },



];


export const maiolica = {
    "title": "Maiolica",
    "subtitle": "COLLECTION",
    "descriptionITA": "Questa collezione con stampa maiolica nei toni del blu e del giallo su fondo bianco è un omaggio ai nostri titoli tipici. Questa collezione ti porta a fare un giro in Vespa con un cestino di limoni!!!",
    "descriptionENG": "This collection featuring Maiolic print in the shades of blue and yellow on a white background is a tribute to our typical titles. This collection pretend to bring you on a Vespa ride with a lemon basket!!!"
};
export const maiolicaProducts = [
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9913.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9913.jpg",
        "retromin": "",

        "prod1": "ABITO MAGNIFICO",
        "stile1": "Maiolica | Prints Color",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9957.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9957.jpg",
        "retromin": "",

        "prod1": "ABITO CONCHIGLIA",
        "stile1": "Bianco | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9963.jpg",
        "retro": "lookbook5/3_maiolica/raw/0S6A9970.jpg",
        "photomin": "lookbook5/3_maiolica/min/0S6A9963.jpg",
        "retromin": "lookbook5/3_maiolica/min/0S6A9970.jpg",

        "prod1": "ABITO ANTIBE",
        "stile1": "Maiolica | Prints Color",
        "taglia1": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9993.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9993.jpg",
        "retromin": "",

        "prod1": "TOP CARAMELLO",
        "stile1": "Maiolica | Prints Color",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "SHORT MYKONOS",
        "stile2": "Maiolica | Prints Color",
        "taglia2": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A0006.jpg",
        "retro": "lookbook5/3_maiolica/raw/ABITO COSTARICA.jpg",
        "photomin": "lookbook5/3_maiolica/min/0S6A0006.jpg",
        "retromin": "lookbook5/3_maiolica/min/ABITO COSTARICA.jpg",

        "prod1": "ABITO COSTARICA",
        "stile1": "Maiolica | Prints Color",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9987.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9987.jpg",
        "retromin": "",

        "prod1": "GONNA VERMENTINO",
        "stile1": "Maiolica | Prints Color",
        "taglia1": "TAGLIA U",

        "prod2": "TOP EMILY",
        "stile2": "Maiolica | Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9987e.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9987e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0028",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9921.jpg",
        "retro": "lookbook5/3_maiolica/raw/0S6A9923.jpg",
        "photomin": "lookbook5/3_maiolica/min/0S6A9921.jpg",
        "retromin": "lookbook5/3_maiolica/min/0S6A9923.jpg",

        "prod1": "ABITO ALIMINI",
        "stile1": "Bianco | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9921e.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9921e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ008",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9928.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9928.jpg",
        "retromin": "",

        "prod1": "ABITO COPACABANA",
        "stile1": "Maiolica | Prints . Solid Colors",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/3_maiolica/raw/0S6A9942.jpg",
        "retro": "",
        "photomin": "lookbook5/3_maiolica/min/0S6A9942.jpg",
        "retromin": "",

        "prod1": "ABITO SOLE",
        "stile1": "Maiolica | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },


]


export const whiteCouture = {
    "title": "White Couture",
    "subtitle": "COLLECTION",
    "descriptionITA": "Capi iconici e senza tempo per il tuo stile di vita quotidiano. Grazie al nostro know-how locale, ci sforziamo di portare la classica tecnica del macramè nelle arti e nella cultura della moda contemporanea.",
    "descriptionENG": "Timeless and iconic garments for your everyday lifestyle. Thanks to our local know-how, we thrive to bring the classic macrame technique into the contemporary fashion arts and culture."
};
export const whiteCoutureProducts = [
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9315.jpg",
        "retro": "",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9315.jpg",
        "retromin": "",

        "prod1": "ABITO MARTINA",
        "stile1": "Sangallo Embroidery Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9218.jpg",
        "retro": "",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9218.jpg",
        "retromin": "",

        "prod1": "ABITO PORTOFINO",
        "stile1": "Fiore Embroidery Color",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "SHORT MYKONOS",
        "stile2": "Fiore Embroidery Color",
        "taglia2": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9310.jpg",
        "retro": "lookbook5/4_whiteCouture/raw/0S6A9305.jpg",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9310.jpg",
        "retromin": "lookbook5/4_whiteCouture/min/0S6A9305.jpg",

        "prod1": "ABITO SALLY",
        "stile1": "Fiore Embroidery Color",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9291.jpg",
        "retro": "",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9291.jpg",
        "retromin": "",

        "prod1": "ABITO DAFNE",
        "stile1": "Sangallo Embroidery Color",
        "taglia1": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9297.jpg",
        "retro": "",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9297.jpg",
        "retromin": "",

        "prod1": "GONNA VODKA",
        "stile1": "Sangallo Embroidery Color",
        "taglia1": "TAGLIA U",

        "prod2": "TOP PALOMA",
        "stile2": "Sangallo Embroidery Color",
        "taglia2": "TAGLIA S.M.L"
    },
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9242.jpg",
        "retro": "",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9242.jpg",
        "retromin": "",

        "prod1": "TOP CARAMELLO",
        "stile1": "Fiore Embroidery Color",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "GONNA ISLA",
        "stile2": "Fiore Embroidery Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/4_whiteCouture/raw/0S6A9267.jpg",
        "retro": "lookbook5/4_whiteCouture/raw/0S6A9255.jpg",
        "photomin": "lookbook5/4_whiteCouture/min/0S6A9267.jpg",
        "retromin": "lookbook5/4_whiteCouture/min/0S6A9255.jpg",

        "prod1": "ABITO LULU'",
        "stile1": "Sangallo Embroidery Color",
        "taglia1": "TAGLIA U"
    },




];


export const paisley = {
    "title": "Paisley",
    "subtitle": "COLLECTION",
    "descriptionITA": "Questa collezione è una miscela di linee sartoriali, basic e colori pop. La nostra nuova proposta per l'estate '23 è piena di colori pop paisley e lino brillante.",
    "descriptionENG": "This collection is a blend throw tailoring lines , basics and pop color. Our new proposal for the ‘23 summer is full of pop paisley colors and bright basics linens."
};
export const paisleyProducts = [
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9851.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9851.jpg",
        "retromin": "",

        "prod1": "PANTALONE MARTE",
        "stile1": "Cashmere Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CASACCA ARANCIA",
        "stile2": "Bianca | Solid Colors",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9903.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9903.jpg",
        "retromin": "",

        "prod1": "ABITO GARDENIA",
        "stile1": "Cashmere Mare | Prints Color",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CINTURA BZ0017",
        "stile2": "Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9856.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9856.jpg",
        "retromin": "",

        "prod1": "TOP CARAMELLO",
        "stile1": "Cashmere Mare | Prints Color",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "GONNA VERMENTINO",
        "stile2": "Cashmere Mare | Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9856e.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9856e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ0022",
        "stile1": "Prints Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9886.jpg",
        "retro": "lookbook5/5_paisley/raw/0S6A9894.jpg",
        "photomin": "lookbook5/5_paisley/min/0S6A9886.jpg",
        "retromin": "lookbook5/5_paisley/min/0S6A9894.jpg",

        "prod1": "ABITO MAKUMBA",
        "stile1": "Cashmere Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9884.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9884.jpg",
        "retromin": "",

        "prod1": "ABITO ANNA",
        "stile1": "Cashmere Mare | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9878.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9878.jpg",
        "retromin": "",

        "prod1": "ABITO NINA",
        "stile1": "Bianco | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CAPPELLO PESCATORE",
        "stile2": "Tigre Mare | Prints . Solid Colors",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9866.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9866.jpg",
        "retromin": "",

        "prod1": "CASACCA PITA",
        "stile1": "Cashmere Mare | Prints Color",
        "taglia1": "TAGLIA U",

        "prod2": "PANTALONE MARTE",
        "stile2": "Bianco | Prints . Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9827.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9827.jpg",
        "retromin": "",

        "prod1": "ABITO CARTUSIA",
        "stile1": "Menta | Solid Color",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9832.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9832.jpg",
        "retromin": "",

        "prod1": "ABITO AGADI",
        "stile1": "Menta | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "TWELLY",
        "stile2": "Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9816.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9816.jpg",
        "retromin": "",

        "prod1": "ABITO NINA",
        "stile1": "Cashmere Menta | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "CAPPELLO PESCATORE",
        "stile2": "Cashmere Menta | Prints Color",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9837.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9837.jpg",
        "retromin": "",

        "prod1": "ABITO PANAREA",
        "stile1": "Cashmere Menta | Prints Color",
        "taglia1": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9820.jpg",
        "retro": "lookbook5/5_paisley/raw/0S6A9823.jpg",
        "photomin": "lookbook5/5_paisley/min/0S6A9820.jpg",
        "retromin": "lookbook5/5_paisley/min/0S6A9823.jpg",

        "prod1": "ABITO MAKUMBA",
        "stile1": "Menta | Prints . Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9812.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9812.jpg",
        "retromin": "",

        "prod1": "CAMICIA MAKI",
        "stile1": "Cashmere Menta | Prints . Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L.XL",

        "prod2": "PANTALONE CAPRI",
        "stile2": "Menta | Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L.XL"
    },
    {
        "photo": "lookbook5/5_paisley/raw/0S6A9802.jpg",
        "retro": "",
        "photomin": "lookbook5/5_paisley/min/0S6A9802.jpg",
        "retromin": "",

        "prod1": "GIACCA PALOMA",
        "stile1": "Cashmere Menta | Prints Color",
        "taglia1": "TAGLIA S.M.L",

        "prod2": "SHORT SAINT BARTH",
        "stile2": "Cashmere Menta | Prints . Solid Colors",
        //todo: taglia sbagliata su catalogo
        "taglia2": "TAGLIA S.M.L.XL",

        "prod3": "CINTURA BZ0019",
        "stile3": "Prints Color",
        "taglia3": "TAGLIA U"
    }
];


export const ramadan = {
    "title": "Ramadan",
    "subtitle": "COLLECTION",
    "descriptionITA": "Scavando nelle radici della cultura mediterranea, mescolando influenze dalla Mesopotamia a Marrakech, la collezione Ramadan ti offre sfumature fresche, un tocco romantico e un'eleganza senza tempo.",
    "descriptionENG": "Delving into the roots of Mediterranean culture, mixing influences from Mesopotamia to Marrakech, Ramadan collection offers you a fresh nuances, romantic touch and timeless elegance."
};
export const ramadanProducts = [
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0218.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0218.jpg",
        "retromin": "",

        "prod1": "ABITO PURE",
        "stile1": "Corallo | Ramadan Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0300.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0300.jpg",
        "retromin": "",

        "prod1": "CAMICIA PANAMA",
        "stile1": "Ecrù | Ramadan Solid Colors",
        "taglia1": "TAGLIA U",

        "prod2": "BERMUDA EROS",
        "stile2": "Ecrù | Ramadan Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0199.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0199.jpg",
        "retromin": "",

        "prod1": "TOP EMILY",
        "stile1": "Ecrù | Ramadan Solid Colors",
        "taglia1": "TAGLIA U",

        "prod2": "GONNA NEVE",
        "stile2": "Garza Ecrù | Ramadan Solid Colors",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0199e.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0199e.jpg",
        "retromin": "",

        "prod1": "CINTURA BZ008",
        "stile1": "Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0184.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0184.jpg",
        "retromin": "",

        "prod1": "TUTA MARE",
        "stile1": "Ecrù | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0189.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0189.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO BELEN",
        "stile1": "Corallo | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0231.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0231.jpg",
        "retromin": "",

        "prod1": "ABITO MAKUMBA",
        "stile1": "Panna | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0232.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0232.jpg",
        "retromin": "",

        "prod1": "SUNRISE",
        "stile1": "Ecrù | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0277.jpg",
        "retro": "lookbook5/6_ramadan/raw/0S6A0272.jpg",
        "photomin": "lookbook5/6_ramadan/min/0S6A0277.jpg",
        "retromin": "lookbook5/6_ramadan/min/0S6A0272.jpg",

        "prod1": "SPOLVERINO ORGOGLIO",
        "stile1": "Ricamo Blue | Ramadan Solid Colors . Embroidery From Picture",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0267.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0267.jpg",
        "retromin": "",

        "prod1": "ABITO EGITTO",
        "stile1": "Panna | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0283.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0283.jpg",
        "retromin": "",

        "prod1": "CASACCA MENTA",
        "stile1": "Panna | Ramadan Solid Colors",
        "taglia1": "TAGLIA U",

        "prod2": "BERMUDA EROS",
        "stile2": "Ecrù | Ramadan Solid Colors",
        "taglia2": "TAGLIA XS.S.M.L"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0290.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0290.jpg",
        "retromin": "",

        "prod1": "PANTALONE MUSA",
        "stile1": "Panna | Ramadan Solid Colors",
        "taglia1": "TAGLIA XS.S.M.L",

        "prod2": "CAMICIA PANAMA",
        "stile2": "Ecrù | Ramadan Solid Colors",
        "taglia2": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0255.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0255.jpg",
        "retromin": "",

        "prod1": "SPOLVERINO POSITANO",
        "stile1": "Panna | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0246.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0246.jpg",
        "retromin": "",

        "prod1": "TUTA META",
        "stile1": "Panna | Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0259.jpg",
        "retro": "lookbook5/6_ramadan/raw/0S6A0260.jpg",
        "photomin": "lookbook5/6_ramadan/min/0S6A0259.jpg",
        "retromin": "lookbook5/6_ramadan/min/0S6A0260.jpg",

        "prod1": "ABITO ORTENSIA",
        "stile1": "Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    },
    {
        "photo": "lookbook5/6_ramadan/raw/0S6A0239.jpg",
        "retro": "",
        "photomin": "lookbook5/6_ramadan/min/0S6A0239.jpg",
        "retromin": "",

        "prod1": "ABITO SAPRI",
        "stile1": "Ramadan Solid Colors",
        "taglia1": "TAGLIA U"
    }

];
